<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-darkgray shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      نرم افزار علم سنجی (Scientometrics) سرمد
                    </h3>

                    <p>
                      نرم ‌افزار علم‌سنجی سرمد ابزاری دقیق است که برای تحلیل و
                      ارزیابی داده‌های علمی و پژوهشی به کار می‌رود. این نرم
                      ‌افزار به کاربران کمک می‌کند تا روندها، الگوها و تاثیرات
                      تحقیقاتی را شناسایی و بررسی کنند و کاربردهای گسترده‌ای در
                      دانشگاه‌ها، مؤسسات تحقیقاتی و شرکت‌های دانش بنیان دارد.
                    </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/product/lab-cuate.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
      <section class="section-tab-product">
        <div class="container-section">
          <tabs :fill="false" class="flex-column">
            <tab-pane key="tab1" class="section-product">
              <template slot="title">
                <h5>
                  مزایای استفاده از نرم ‌افزار علم‌سنجی
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          ارزیابی دقیق
                        </h5>
                      </div>
                      <p class="pt-2">
                        ارائه ارزیابی‌های دقیق از اثرگذاری تحقیقات و عملکرد
                        پژوهشگران
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          بهبود تصمیم‌گیری
                        </h5>
                      </div>
                      <p class="pt-2">
                        ارائه داده‌های دقیق و تحلیل‌های کاربردی برای
                        تصمیم‌گیری‌های استراتژیک
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          شناسایی فرصت‌ها
                        </h5>
                      </div>
                      <p class="pt-2">
                        کمک به شناسایی فرصت‌های جدید تحقیقاتی و همکاری‌های
                        بالقوه
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          افزایش بهره‌وری
                        </h5>
                      </div>
                      <p class="pt-2">
                        بهینه‌سازی فرآیندهای پژوهشی و افزایش کارایی
                      </p>
                    </li>
                  </ul>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pl-0"
                >
                  <h5>
                    استفاده از نرم افزار علم سنجی سرمد به چه کسانی پیشنهاد
                    می‌شود؟
                  </h5>
                  <ul class="list-product">
                    <li>پژوهشگران و دانشگاهیان</li>
                    <li>مدیران دانشگاه‌ها و مؤسسات تحقیقاتی</li>
                    <li>سیاست‌گذاران علمی</li>
                    <li>ناشران علمی</li>
                    <li>کتابداران و متخصصان اطلاعات</li>
                    <li>
                      شرکت‌های دانش بنیان و شتابدهنده‌های حوزه علم و فناوری
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
            <tab-pane key="tab2" class="section-product">
              <template slot="title">
                <h5>
                  قابلیت‌های نرم‌افزار علم سنجی سرمد
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          ابزار گزارش‌ساز پیشرفته
                        </h5>
                      </div>
                      <p class="pt-2">
                        تولید گزارش‌های جامع و ارائه تحلیل‌های آماری از داده‌های
                        علمی برای تصمیم‌گیری بهتر
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          نقشه توزیع مشارکت داخلی و بین‌المللی
                        </h5>
                      </div>
                      <p class="pt-2">
                        ایجاد نقشه‌های علمی برای نمایش ارتباطات و همکاری‌های
                        بین‌المللی و بین‌ استانی کشور
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت داده‌ها
                        </h5>
                      </div>
                      <p class="pt-2">
                        طبقه بندی دقیق اطلاعات، تحلیل استنادی از طریق ارزیابی
                        تعداد و نوع استنادها برای سنجش تاثیرگذاری مقالات و
                        نویسندگان، تحلیل داده‌ها برای شناسایی موضوعات و حوزه‌های
                        در حال رشد و آینده‌دار
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت کاربران
                        </h5>
                      </div>
                      <p class="pt-2">
                        تعیین سطوح دسترسی متفاوت به پژوهشگران بر اساس نیاز و نقش
                        آنها، ایجاد پروفایل کاربری شخصی شامل اطلاعات و جزئیات
                        فعالیت‌های علمی فرد، طبقه بندی و ارزیابی علمی پژوهشی
                        محققان، مؤسسات و سازمان‌ها با استفاده از شاخص‌های مختلف
                        مانند شاخص هرش (H-index)
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت درخواست‌ها
                        </h5>
                      </div>
                      <p class="pt-2">
                        مدیریت و پیگیری درخواست حمایت‌های مالی، تخصیص گرنت و
                        امتیازات پژوهشی
                      </p>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
          </tabs>
        </div>
      </section>
    </div>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  name: "Scientometrics",
  components: {
    Tabs,
    TabPane,
  },
  data() {
    return {
      showScrollButton: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
